import LargeQuote from "./LargeQuote";

const LargeQuoteWithProps = ({ blok }) => {
  return <LargeQuote quote={blok.quote} quoteeRole={blok.quoteeRole} quoteeName={blok.quoteeName} logo={blok.logo} />;
};

export default LargeQuoteWithProps;
